module.exports = __webpack_public_path__ + "static/landing-image-02-d898ca6cbd59a6373d3edf332679b0a0.png";